window.addEventListener("load", function() {
    // Initialize all swipers dynamically
    document.querySelectorAll('[data-swiper-main]').forEach(mainEl => {
        const type = mainEl.dataset.swiperMain;
        const thumbEl = document.querySelector(`[data-swiper-thumb="${type}"]`);

        if (thumbEl) {
            const thumbSwiper = new Swiper(thumbEl, {
                slidesPerView: 5,
                spaceBetween: 0,
                slideToClickedSlide: true,
                breakpoints: {
                    751: {
                        slidesPerView: 5,
                    }
                }
            });

            new Swiper(mainEl, {
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 0,
                thumbs: {
                    swiper: thumbSwiper,
                },
                // navigation: {
                //     nextEl: document.querySelector('#naraka-ms-25-media-content').querySelector('.swiper-button-next'),
                //     prevEl: document.querySelector('#naraka-ms-25-media-content').querySelector('.swiper-button-prev'),
                // },
            });
        }
    });

    
});